import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCamera1"><Path d="M2.5 6.5H7.5L9.5 3.5H14.5L16.5 6.5H21.5V20.5H2.5V6.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 13C15.5 14.933 13.933 16.5 12 16.5C10.067 16.5 8.5 14.933 8.5 13C8.5 11.067 10.067 9.5 12 9.5C13.933 9.5 15.5 11.067 15.5 13Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCamera1;
